import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { patchCustomTheme } from 'redux/themes/actions';

import ColorPicker from 'components/dashboard/appearance-content/ColorPicker';
import ProLabel from 'components/common/ProLabel';
import ProFeaturePlaceholder from 'components/common/ProFeaturePlaceholder';

import './CryptoColorSelector.css';


function CryptoColorSelector(props) {
  const { me, parameter, patchCustomTheme, label, type } = props;
  const { t } = useTranslation();

  const [currentColor, setCurrentColor] = useState(me && me.custom_theme && me.custom_theme[`${parameter}`]);

  const onColorChange = color => {
    const { r, g, b, a } = color.rgb;
    const rgba = `rgba(${r}, ${g}, ${b}, ${a})`;
    setCurrentColor(rgba);
    const customThemeId = me && me.custom_theme && me.custom_theme.id;
    const form = new FormData();
    form.append(parameter, rgba);
    patchCustomTheme(customThemeId, form);
  };

  return (
    <div className="crypto-color-selector__component">
      <div className="label-wrapper">
        <div className="text">{label}</div>
        <ProLabel />
      </div>
      <ProFeaturePlaceholder
        noKeyIcon
        locked={
          me &&
          me.subscription &&
          !me.subscription.ff_crypto_links
        }
        placeholderContent={
          <div>
            {t("You can change colors on the PRO plan.")}
          </div>
        }
      >
        <ColorPicker
          small
          key={`crypto-color-picker-key-${type}`}
          pickerId={`crypto-color-picker-id-${type}`}
          color={currentColor}
          onChangeComplete={onColorChange}
        />
      </ProFeaturePlaceholder>
    </div>
  );
};

CryptoColorSelector.propTypes = {
  patchCustomTheme: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  me: PropTypes.object,
  parameter: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

CryptoColorSelector.defaultProps = {
  me: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
  }
);

export default connect(
  mapStateToProps,
  {
    patchCustomTheme,
  },
)(CryptoColorSelector);
